<template>
  <div class="row mt-3">
    <div v-for="i in article.images" :key="i.map_id" class="col-sm">
      <b-card
        :title="i.map_id"
        :img-src="baseurl + 'rest/data/images/' + encodeURIComponent(article.map_pic_id) + '/' + i.lfdnr"
        img-alt="Image"
        img-top
        @click="openImg(i)"
        tag="article"
        style="max-width: 20rem;"
        class="mb-2"
      >
        <b-card-text>
          {{ i.desc }}
        </b-card-text>
      </b-card>
    </div>
    <b-modal id="fsImage" hide-footer size="xl" title="Artikelbild" ok-only>
      <img :src="bigurl" />
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'ArticleImages',
  props: ["article","baseurl"],
  data() {
    return {
      bigurl: ""
    }
  },
  methods: {
    openImg: function(img) {
      console.log(img);
      this.bigurl = this.baseurl + 'rest/data/images/' + encodeURIComponent(this.article.map_pic_id) + '/' + img.lfdnr;
      this.$bvModal.show('fsImage');
    }
  }
}
</script>
